import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
@Component({
  selector: 'app-insenctive-report',
  templateUrl: './insenctive-report.component.html',
  styleUrls: ['./insenctive-report.component.scss']
})
export class InsenctiveReportComponent implements OnInit {
  is_document_available: boolean = true;
  document_file: any = null;
  from_date: any = null;
  to_date: any = null;
  option_list = [{ "display_name": 'Amount', "value": 'amount' }, { "display_name": 'Precentage', "value": 'precentage' }];
  seleted_option_type: any = null;
  option_value: any = 0;
  incentive_for_list = [{ "display_name": 'Cash', "value": 'agent' }, { "display_name": 'Card', "value": 'icustomer' }, { "display_name": 'Cash+Card', "value": 'both' }];
  selected_incentive_for: any;
  is_tds_deduction_included: boolean = false;
  tds_value: any = 0;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title: any;

  constructor(private httpService: HttpService, private dialog: MatDialog, private global: GlobalService) {
    this.title = this.global._active_display_name;
  }

  getClicked() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date,
      'option_type': this.seleted_option_type,
      'option_value': this.option_value,
      'selected_incentive_for': this.selected_incentive_for,
      'tds_deduction': this.is_tds_deduction_included,
      'tds_value': this.tds_value
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.serveIncentiveReport(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }

  tdsDeductionChange(event) {
    console.log(event.value)
    return true
  }

  downloadClickedForPdf() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['pdf_file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  downloadClickedForExcel() {
    const linkSource = 'data:application/xlsx;base64,' + this.document_file['excel'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['excel_file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  changeOption() {
    console.log('data changes')
    this.option_value = 0;
    this.is_tds_deduction_included = false;
    this.tds_value = 0;
  }

  ngOnInit() {
  }

}
